<template>
    <div class="campaign-visual">
        <!-- <img class="placehold" src="/static/img/campaign-visual.png" /> -->
        <h2 class="name" :style="{ fontSize: size * 0.32 + 'px', bottom: size * 0.88 + 'px' }">Ballenbak</h2>

        <div class="box" :style="{ width: size + 'px' }">
            <img class="lid" src="/static/img/landing/lid.png"/>

            <div class="lower-box">
                <div class="balls inside">
                    <img class="stack stack0" src="/static/img/landing/layer_1.png" />
                    <img class="stack stack1" src="/static/img/landing/layer_2.png" />
                    <img class="stack stack2" src="/static/img/landing/layer_3.png" />
                    <img class="stack stack3" src="/static/img/landing/layer_4.png" />
                    <img class="stack stack4" src="/static/img/landing/layer_5.png" />
                </div>

                <img src="/static/img/landing/box-front.png" />
            </div>
            <div class="balls outside">

                    <div class="ball32">
                        <div class="shadow"></div>
                        <img src="/static/img/landing/ball32.png" />
                    </div>

                    <div class="ball24">
                        <div class="shadow"></div>
                        <img src="/static/img/landing/ball24.png" />
                    </div>

                    <div class="outer-ball ball22">
                        <img src="/static/img/landing/ball22.png" />
                    </div>

                    <div class="outer-ball ball13">
                        <img src="/static/img/landing/ball13.png" />
                    </div>

                    <div class="outer-ball ball9">
                        <img src="/static/img/landing/ball9.png" />
                    </div>

                    <div class="outer-ball ball12">
                        <img src="/static/img/landing/ball12.png" />
                    </div>

                    <div class="ball23">
                        <div class="shadow"></div>
                        <img src="/static/img/landing/ball23.png" />
                    </div>

                    <div class="outer-ball ball26">
                        <img src="/static/img/landing/ball26.png" />
                    </div>

                </div>
            <img class="lid front" src="/static/img/landing/lid-front.png" />
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    /* eslint-disable */
    import { TweenMax, TimelineMax } from '@/vendor';

    export default {
        props: {
            size: {
                type: Number,
                default: 250
            }
        },

        mounted()
        {
            this.tl = new TimelineMax({ paused: true });

            const TIME_GOING_UP = 0.2;
            const TIME_GOING_DOWN = 0.3;
            const OUTER_BALL_DROP_TIME = 2;

            let fallDownEase = CustomEase.create( 'custom', 'M0,0,C0.228,0,0.402,1.072,0.6,1.072,0.8,1.072,0.908,1,1,1' );

            TweenMax.set( '.campaign-visual .name', { x: '-50%', rotation: 0.01, willChange: 'transform' } );
            TweenMax.set( '.ball22', { y: '-=35%' } );
            TweenMax.set( '.ball13', { y: '-=14%' } );
            TweenMax.set( '.ball9',  { y: '-=27%' } );
            TweenMax.set( '.ball12', { y: '-=49%' } );
            TweenMax.set( '.ball26', { x: '-=11%', y: '-=20%' } );

            let innerTimeline = new TimelineMax({ paused: true })
                .addLabel( 'lid-open', 0 )
                .addLabel( 'top', 'lid-open+=' + TIME_GOING_UP )
                .addLabel( 'end', 'top+=' + TIME_GOING_DOWN )

                // .to( '.lid', 0.4, { y: '-=180%', ease: Sine.easeOut }, 'lid-open' )
                .to( '.lid', 1.75, { y: '-=115%', ease: Expo.easeOut }, 'lid-open' )
                .to( '.outer-ball', 0.4, { y: '-=70%', ease: Sine.easeOut }, 'lid-open' )

                .fromTo( '.stack0, .stack4', TIME_GOING_UP, { y: 15 }, { y: -10, ease: Sine.easeOut }, 'lid-open' )
                .fromTo( '.stack1, .stack3', TIME_GOING_UP, { y: 15 }, { y: -30, ease: Sine.easeOut }, 'lid-open' )
                .fromTo( '.stack2',          TIME_GOING_UP, { y: 15 }, { y: -50, ease: Sine.easeOut }, 'lid-open' )

                .fromTo( ['.ball22', '.ball13', '.ball9', '.ball12', '.ball26'], 0.2, { autoAlpha: 0 }, { autoAlpha: 1 }, 'lid-open+=0.5' )

                .to( '.ball22', OUTER_BALL_DROP_TIME, { y: '0%', ease: Power2.easeOut }, 'lid-open+=0.25' )
                .to( '.ball13', OUTER_BALL_DROP_TIME, { y: '0%', ease: Power2.easeOut }, 'lid-open+=0.25' )
                .to( '.ball9',  OUTER_BALL_DROP_TIME, { y: '0%', ease: Power2.easeOut }, 'lid-open+=0.25' )
                .to( '.ball12', OUTER_BALL_DROP_TIME, { y: '0%', ease: Power2.easeOut }, 'lid-open+=0.25' )
                .to( '.ball26', OUTER_BALL_DROP_TIME, { x:'0%', y: '0%', ease: Power2.easeOut }, 'lid-open+=0.25' )

                // .from( '.campaign-visual .name', 1, { y: '+=200%', ease: Sine.easeOut }, 'lid-open-=0.2' )
                .from( '.campaign-visual .name', 0.3, { autoAlpha: 0, ease: Power2.easeOut }, 'lid-open+=0.1' ) // 0.4
                .from( '.campaign-visual .name', 1.7, { scale: 0.3, ease: Expo.easeOut }, 'lid-open+=0.1' )

                .to( '.stack0, .stack4', TIME_GOING_DOWN, { y: 0, ease: fallDownEase }, 'top' )
                .to( '.stack1, .stack3', TIME_GOING_DOWN, { y: 0, ease: fallDownEase }, 'top' )
                .to( '.stack2',          TIME_GOING_DOWN, { y: 0, ease: fallDownEase }, 'top' )

            var totalDuration = innerTimeline.totalDuration();

            this.tl.to( innerTimeline, 3, { progress: 1, ease: Power2.easeOut }, 1)
        },

        methods: {
            getAnim()
            {
                return this.tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/LandingVisual.vue